module.exports = __webpack_public_path__ + "media/images/sp/stores/kyoto/main-visual-cb95b0b3f1e2a76bd2e985d98265dddb.jpg";